var _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankRecurringPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 136,
    viewBox: "0 0 195 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 17,
    width: 53,
    height: 53,
    rx: 26.5,
    transform: "rotate(90 157.5 17)",
    fill: "#F2E9FB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46,
    cy: 20.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 46 20.5)",
    fill: "#00FFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1011 77.509C43.5505 77.6737 43.5504 78.326 43.101 78.4905C37.2256 80.6413 35.1409 82.7253 32.9905 88.6008C32.826 89.0502 32.1736 89.0504 32.0089 88.601C29.8568 82.7277 27.7739 80.6438 21.8989 78.491C21.4495 78.3263 21.4496 77.674 21.899 77.5095C27.7744 75.3587 29.8592 73.2747 32.0095 67.3992C32.174 66.9498 32.8264 66.9496 32.9911 67.399C35.1432 73.2723 37.2261 75.3562 43.1011 77.509Z",
    fill: "url(#paint0_linear_26951_21606)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.138 57.8651H56.8656C53.0626 57.8651 51.4327 53.6664 54.4209 51.6702L94.5569 25.0319C95.2979 24.5901 96.142 24.3571 97.0017 24.3571C97.8614 24.3571 98.7056 24.5901 99.4466 25.0319L139.582 51.6702C142.571 53.6664 140.941 57.8651 137.138 57.8651Z",
    stroke: "url(#paint1_linear_26951_21606)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.748 95.2167H56.253C54.3777 95.2167 52.8574 96.7772 52.8574 98.7018V109.158C52.8574 111.082 54.3777 112.643 56.253 112.643H137.748C139.623 112.643 141.143 111.082 141.143 109.158V98.7018C141.143 96.7772 139.623 95.2167 137.748 95.2167Z",
    stroke: "url(#paint2_linear_26951_21606)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0439 57.8653V95.2167",
    stroke: "url(#paint3_linear_26951_21606)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6807 57.8653V95.2167",
    stroke: "url(#paint4_linear_26951_21606)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.319 57.8653V95.2167",
    stroke: "url(#paint5_linear_26951_21606)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.957 57.8653V95.2167",
    stroke: "url(#paint6_linear_26951_21606)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26951_21606",
    x1: 44.2273,
    y1: 77.8033,
    x2: 5.03146,
    y2: 90.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26951_21606",
    x1: 140.126,
    y1: 40.8365,
    x2: 50.2766,
    y2: 120.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26951_21606",
    x1: 140.14,
    y1: 103.787,
    x2: 99.064,
    y2: 173.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26951_21606",
    x1: 64.0326,
    y1: 76.2348,
    x2: 62.2145,
    y2: 76.2512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26951_21606",
    x1: 86.6693,
    y1: 76.2348,
    x2: 84.8513,
    y2: 76.2512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26951_21606",
    x1: 109.308,
    y1: 76.2348,
    x2: 107.49,
    y2: 76.2512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26951_21606",
    x1: 131.946,
    y1: 76.2348,
    x2: 130.128,
    y2: 76.2512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankRecurringPayment);
export default __webpack_public_path__ + "static/media/bank-recurring-payment.0c74af2cb8d753ffbc13fff9ef0dddc4.svg";
export { ForwardRef as ReactComponent };